import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Emilus";
export const API_BASE_URL =
  "https://trukkers-konnect-2e73c4741c00.herokuapp.com";
// export const API_BASE_URL = env.API_BASE_URL || "http://localhost:8000";
// export const API_BASE_URL = "http://192.168.100.226:8000";
// Support contacts shown to users (Contact Support page). Defined once here
// so they only ever need changing in one place.
export const SUPPORT_EMAILS = [
  "info@truckerskonnect.com",
];

export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const UNAUTHENTICATED_ENTRY = "/login";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
